import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=c22e357e&scoped=true&"
import script from "./ChatHeader.vue?vue&type=script&lang=js&"
export * from "./ChatHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22e357e",
  null
  
)

export default component.exports